<template>
    <div class="recommend">
        <p-header title="推薦領好禮"/>
        <div class="body">
            <div class="center">
                <div class="icon">
                    <img src="@/assets/img/gift.png">
                </div>
                <div class="code">
                    <div class="title">
                        推薦碼
                    </div>
                    <div class="copy">
                        <div>{{ user.invite_code }}</div>
                        <img src="@/assets/img/copy.svg" @click="copyCode">
                    </div>
                </div>
                <div class="description">
                    邀請朋友，獲得＄50<br>
                    <br>
                    1.你的朋友將獲得100元優惠卷<br>
                    需註冊時輸入你的推薦碼<br>
                    <br>
                    2.你也將獲得50元優惠卷<br>
                    當朋友實際完成首次任務時<br>
                </div>
                <div class="buttons">
                    <div class="button" v-show="isSupportNavigatorShare" @click="shareCode">
                        <img src="@/assets/img/share.svg">
                        分享
                    </div>
                    <div class="button" @click="showQRcode">
                        <img src="@/assets/img/QRcode.svg">
                        QR code
                    </div>
                </div>
            </div>
            <div class="tip">
                <div class="title">
                    注意事項
                    <img src="@/assets/img/question-green.svg">
                </div>
                僅限朋友首次註冊使用。
            </div>
            <div class="total">
                <div class="title">
                    已推薦 <span>{{ count }}位</span> 親友
                </div>
                <router-link tag="div" class="button" :to="{name: 'coupons'}">
                    查看獎勵
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
        </div>
        <qrcode ref="qr"/>
    </div>
</template>

<script>
    import header from "./components/Header";
    import Swal from "sweetalert2";
    import { mapGetters } from 'vuex';
    import { invitedCount } from '../apis';
    import RecommendQRCodeModal from "./components/modal/RecommendQRCodeModal";

    export default {
        name: "Recommend",
        components: {
            'p-header': header,
            'qrcode': RecommendQRCodeModal,
        },
        data() {
          return {
              count: 0,
          }
        },
        computed: {
            isSupportNavigatorShare() {
                return navigator.share ? true : false;
            },
            shareUrl() {
              return window.location.origin + this.$router.resolve({name: 'login', query: { 'ic': this.user.invite_code }}).href;
            },
            ...mapGetters(['user'])
        },
        methods: {
            showQRcode() {
                this.$refs.qr.show(this.shareUrl);
            },
            copyCode() {
                let textArea  = document.createElement('textarea');
                textArea.width  = "1px";
                textArea.height = "1px";
                textArea.background =  "transparents";
                textArea.value = `快輸入我的註冊推薦碼 ${this.user.invite_code} 就可獲得『跑跑腿』首次使用100元優惠卷一張\n立即使用跑跑腿，即刻出發，為了你的願望～\n${this.shareUrl}`;
                document.body.append(textArea);
                textArea.select();

                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        Swal.fire({
                            title: '複製完成!',
                            type: 'success',
                            timer: 2000,
                        })
                    }
                } catch (err) {
                    Swal.fire({
                        title: 'Oops...',
                        text: '複製失敗，請嘗試手動複製。',
                        type: 'error',
                    })
                }

                document.body.removeChild(textArea);
            },
            shareCode() {
                navigator.share({
                    title: '跑跑腿',
                    text: `快輸入我的註冊推薦碼 ${this.user.invite_code} 就可獲得『跑跑腿』首次使用100元優惠卷一張\n立即使用跑跑腿，即刻出發，為了你的願望～\n${this.shareUrl}`,
                });
            }
        },
        created() {
            invitedCount().then(res => {
                this.count = res.data.count;
            });
        },
    }
</script>

<style lang="scss" scoped>
    .recommend {
        flex: 1;
        display: flex;
        flex-direction: column;

        .body {
            margin: 15px;
            display: flex;
            flex-direction: column;
            flex: 1;

            .center {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .icon {
                margin-top: 15px;
                user-select: none;

                img {
                    width: 160px;
                    height: 160px;
                }
            }

            .code {
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .title {
                    color: #4A4A4A;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .copy {
                    background-color: #FAFAFA;
                    display: flex;
                    align-items: center;
                    padding: 5px 15px;
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;

                    img {
                       margin-left: 5px;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }

            .description {
                margin-top: 10px;
                color: #4A4A4A;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 22px;
                text-align: center;
            }

            .buttons {
                margin-top: 25px;
                display: flex;
                justify-content: center;

                .button {
                    cursor: pointer;
                    user-select: none;
                    box-sizing: border-box;
                    border: 1px solid #339933;
                    border-radius: 16px;
                    padding: 3px 15px;
                    display: flex;
                    align-items: center;
                    color: #339933;
                    font-size: 16px;
                    letter-spacing: 0;
                    line-height: 22px;

                    img {
                        margin-right: 5px;
                    }

                    &:nth-child(even) {
                        margin-left: 10px;
                    }
                }
            }
        }

        .tip {
            margin-top: 20px;
            color: #9B9B9B;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            text-align: left;
            padding: 15px;

            .title {
                display: flex;
                align-items: center;
            }
        }

        .total {
            margin-top: 15px;
            border-radius: 5px;
            background-color: #8CC98C;
            padding: 15px 25px;
            display: flex;
            color: #FAFAFA;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            text-align: left;
            justify-content: space-between;
            align-items: center;

            .title {
                span {
                    color: #FFFFFF;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }
            }

            .button {
                display: flex;
                align-items: center;
                cursor: pointer;
                user-select: none;
            }
        }
    }
</style>